import React from "react"
import styled from "styled-components"

export const SubSectionTitle = styled.div`
  font-size: 18px;
  font-variant: all-small-caps;
  font-weight: bold;
`
